export const getChannelAndScopeKey = (
  channelName: string,
  scope: string | number | undefined,
) => (scope ? `private-${channelName.toLowerCase()}-${scope}` : channelName);
